import { API_BASE_URL } from "utils/constants";

const SecurityMonitoringConfigPaths = {
    get_log_metadata: `${API_BASE_URL}/log_management/metadata`,

    delete_log_metadata: `${API_BASE_URL}/log_management/metadata/`,

    delete_log: `${API_BASE_URL}/log_management/log/`,

    get_log: `${API_BASE_URL}/log_management/log`,

    get_metadata_log_name: `${API_BASE_URL}/log_management`,

    update_metadata_log_name: `${API_BASE_URL}/log_management/metadata/`,

    export_log_name: `${API_BASE_URL}/log_management/log/export/`,
    
    upload_log_file: `${API_BASE_URL}/log_management/log/upload`,

    create_metadata: `${API_BASE_URL}/log_management/metadata`,

    lastest_update: `${API_BASE_URL}/log_management/latest-update`,

    job_status: `${API_BASE_URL}/job/process_uploaded_log/:id/get_status`
  };
  
export default SecurityMonitoringConfigPaths;
  